import axios from "axios";
import xss from "xss";

import { rightActions, authActions, kundenActions } from ".";
import { getErrorResponseMessage } from '../utils/functions/response';
import { RESPONSE_HEADER } from "../utils/enums";

export function initConfig(data) {
  return {
    type: 'INIT',
    payload: data
  };
}

export const fetchSession = (axiosObject) => async dispatch => {
  let error = false;
  try {
    const response = await axios[axiosObject.request.type](axiosObject.url, axiosObject.json, axiosObject.request.config);
    if (response && response.data && response.data.header && response.data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL) {
      const data = await dispatch(setSessionData(response.data.header));
      if (response.data.token) {
        dispatch(setAuthToken(response.data.token));
      }
      // ensure bankId is properly set (bankId is not part of header)
      if (response.data.bankId) {
        dispatch(setBankId(response.data.bankId));
      }
      if (response.data.kunde && response.data.kunde.kundenId) {
        dispatch(authActions.signIn(response.data.kunde.kundenId));
        dispatch(kundenActions.setKundenId(response.data.kunde.kundenId));
      }
      //store received rage rights in right-storage
      if (response.data.mitarbeiter) {
        if (Array.isArray(response.data.mitarbeiter.listRageRights)) {
          dispatch(rightActions.setCurrentRight(response.data.mitarbeiter.listRageRights));
        }
        if (response.data.mitarbeiter.mitarbeiterId) {
          dispatch(authActions.beraterLogon({ ...response.data.mitarbeiter, userId: response.data.mitarbeiter.mitarbeiterId }));
        }
      }

      return data.sessionId;
    } else {
      if (response.data && response.data.header && response.data.header.errorNr) {
        error = new Error(xss(`Fehler ${response.data.header.errorNr} - ${response.data.header.errorMsg || ""}`));
        if (String(response.data.header.errorNr) === "91201") {
          error = new Error("Fehler 91201 - Unbekannter Mandant");
        }
      } else {
        error = new Error("Ein Übertragungsfehler ist aufgetreten");
      }
      throw error;
    }
  } catch (e) {
    console.error(e, error);
    if (localStorage.getItem("mandantIdLink") === "invalidMandant") {
      throw new Error("Fehler 91201 - Unbekannter Mandant");
    } else if (error) {
      throw error;
    }
    throw new Error("Ein Übertragungsfehler ist aufgetreten");
  }
};

export const restartSession = (axiosObject) => async dispatch => {
  try {
    const response = await axios[axiosObject.request.type](axiosObject.url, axiosObject.json, axiosObject.request.config);
    if (
      response &&
      response.data &&
      response.data.header &&
      response.data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL
    ) {
      await dispatch(setSessionData(response.data.header));
      // ensure bankId is properly set after restart
      if (response.data.bankId) {
        await dispatch(setBankId(response.data.bankId));
      }

      if (response.data.kunde && response.data.kunde.kundenId) {
        await dispatch(authActions.signIn(response.data.kunde.kundenId));
        await dispatch(kundenActions.setKundenId(response.data.kunde.kundenId));
      }
      //store received rage rights in right-storage
      if (response.data.mitarbeiter) {
        if (Array.isArray(response.data.mitarbeiter.listRageRights)) {
          await dispatch(rightActions.setCurrentRight(response.data.mitarbeiter.listRageRights));
        }
        if (response.data.mitarbeiter.mitarbeiterId) {
          await dispatch(authActions.beraterLogon({ ...response.data.mitarbeiter, userId: response.data.mitarbeiter.mitarbeiterId }));
        }
      }
      await dispatch({
        type: 'RESTART_SESSION',
      });
    } else if (
      response &&
      response.status < 400 &&
      !response.data
    ) {
      dispatch({
        type: 'RESTART_SESSION',
      });
    } else {
      const message = getErrorResponseMessage(response) || "e2: Ein Übertragungsfehler ist aufgetreten";
      throw new Error(message);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const fetchAuth = (axiosObject) => async dispatch => {
  let config = {
    headers: {
      request: JSON.stringify(axiosObject.json.header)
    }
  };
  //neue axios instanz erzeugt, damit interceptor nicht hier greift
  let axiosLogin = axios.create(config);
  //bei get wird hier einfach ein body parameter mitgegeben, der keine Auswirkung hat
  const response = await axiosLogin[axiosObject.request.type](axiosObject.url, axiosObject.json, axiosObject.request.config);
  if (response && response.data && response.data.header && response.data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL) {
    if (response.data.tokenId) {
      dispatch(setAuthToken(response.data.tokenId));
    }
    dispatch(authActions.beraterLogon({ ...(response.data.mitarbeiter || {}), userId: axiosObject.json.userId }));
    //store received rage rights in right-storage (will unmount MALogin)
    if (Array.isArray(response.data.listRageRights)) {
      dispatch(rightActions.setCurrentRight(response.data.listRageRights));
    }
    return response.data;
  } else if (response && response.data && response.data.header && response.data.header.status === RESPONSE_HEADER.STATUS.NO_SUCCESS) {
    return {
      timeout: 60,
      message: xss(response.data.header.errorMsg)
    };
  } else {
    throw new Error("e3: Ein Übertragungsfehler ist aufgetreten");
  }
};

export function setSessionId(id) {
  return {
    type: 'SET_SESSION_ID',
    payload: id
  };
}

export function setTanAuth(id) {
  return {
    type: 'SET_TAN_AUTH',
    payload: id
  };
}

export function setActiveTimeout(active) {
  return {
    type: 'SET_ACTIVE_TIMEOUT',
    payload: active
  };
}

export function setSessionData(data) {
  return {
    type: 'SET_SESSION_DATA',
    payload: data
  };
}

export function resetSession() {
  return {
    type: 'RESET_SESSION',
  };
}

export function setAuthToken(authToken) {

  return {
    type: 'SET_AUTH_TOKEN',
    payload: authToken
  };
}

export function setBankId(id) {
  return {
    type: 'SET_BANK_ID',
    payload: id
  };
}

export function setRenderLandingPage(flag) {
  return {
    type: 'SET_RENDER_LANDINGPAGE',
    payload: flag
  };
}

export function setTimoutPopupStatus(status) {
  return {
    type: 'SET_TIMEOUT_POPUP_STATUS',
    payload: status
  };
}

export function setAppId(appId) {
  return {
    type: 'SET_APP_ID',
    payload: appId
  };
}

export function setVerwaltung(isVerwaltung) {
  return {
    type: 'SET_VERWALTUNG',
    payload: isVerwaltung
  };
}

export function setCallcenter(isCallcenter) {
  return {
    type: 'SET_CALLCENTER',
    payload: isCallcenter
  };
}

export function setLightShop(isLightShop) {
  return {
    type: 'SET_LIGHT_SHOP',
    payload: isLightShop
  };
}

export function setMitarbeiterKonditionen(isMaKond) {
  return {
    type: "SET_MA_KOND",
    payload: isMaKond
  };
}

export function loadingMaKond(bool) {
  return {
    type: "SET_LOADING_MA_KOND",
    payload: !!bool
  };
}
